/* globals urls, validate */

// Add custom validator for detecting HTML tags
validate.validators.noTags = function(value, options, key, attributes) {
	var message = options.message || this.message || 'cannot contain HTML tags';
	if(validate.isString(value)){
		//var pattern = new RegExp(/(.*|.*\n)<[a-z][\s\S]*>(\n.*|.*)/, 'gi');
		// Switching to regex literal because IE sucks, and can't handle anything but a string in the RegExp constructor
		var pattern = /(.*|.*\n)<[a-z][\s\S]*>(\n.*|.*)/gi;
		var match = pattern.exec(value);
		if(match){
			return message;
		}
	}
};

var $ = jQuery.noConflict();
var arrDeleteSocialMediaRows = [];
var arrDeleteEducationRows = [];
window.ProfileHelper = function(strProfilePage){
	this.initProfileData = {};
	this.ignoreDataChanges = false;
	this.page = strProfilePage;
};

// Helper function to check the specified values object values HTML tags
ProfileHelper.prototype.checkForTags = function(objValues){
	var objFormConstraints = {};
	$.each(objValues, function(key, value){
		objFormConstraints[key] = {noTags: true};
	});
	
	return validate(objValues, objFormConstraints);
};

// Helper function to set the initial profile data for this form
ProfileHelper.prototype.setInitProfileData = function(objData){
	this.initProfileData = JSON.stringify(objData);
};

// Helper function to check for any changes made to this profile form, based on previously-saved initProfileData from the initial state of the form
// Always returns false if the ignoreDataChanges property is set to true (to allow for redirection after successful registration/update)
ProfileHelper.prototype.dataHasChanged = function(objCurrentData){
	if(this.ignoreDataChanges === true){
		return false;
	}
	return this.initProfileData !== JSON.stringify(objCurrentData);
};

// Helper function to check if a country name represents the US or Canada
ProfileHelper.prototype.isUsOrCanada = function(strCountry){
	var blnRet = false;

	// Assume no value is true, to show the state dropdown when no country is shown
	if(!strCountry){
		return true;
	}

	switch(strCountry){
		case 'Canada':
		case 'Can':
		case 'CAN':
		case 'United States':
		case 'United States of America':
		case 'United States Of America':
		case 'US':
		case 'U.S.':
		case 'USA':
		case 'U.S.A.':
		case '': // Assume no value is true, to show the state dropdown when no country is shown
			blnRet = true;
			break;
	}

	return blnRet;
};

// Helper function to check if a specialty has additional fields to fill out when registering/editing a profile
ProfileHelper.prototype.isSpecialtyWithAdditionalFields = function(strSpecialty){
	var blnReturn = true;

	if(!strSpecialty){
		return false;
	}

	switch(strSpecialty.toLowerCase()){
		case 'dental staff':
		case 'general dentist':
		case 'general practice':
		case 'laboratory tech':
		case 'laboratory technician':
		case 'other':
		case '':
			blnReturn = false;
			break;
	}

	return blnReturn;
};

// Helper function to get the data for all education rows currently on the page
ProfileHelper.prototype.getEducationRowData = function(){
	var arrEducationRows = [];
	$('.edu-block').each(function(){
		var strDegreeType = $(this).find('#edu-type-00').val();
		var strDegreeSchool = $(this).find('#edu-school-00').val();
		var strDegreeYear = $(this).find('#edu-yr-grad-00').val();
		var strDegreeName = $(this).find('#edu-deg-00').val();
		var strRecordId = $(this).find('#edu-record-id-00').val();
		var strCollegeId =$(this).find('#edu-college-id-00').val();
		var objData = {
			DegreeType: strDegreeType,
			School: strDegreeSchool,
			YearGraduated: strDegreeYear,
			Degree: strDegreeName,
			College: strCollegeId
		};
		if(strRecordId){
			objData.RecordID = strRecordId;
		}

		arrEducationRows.push(objData);
	});

	return arrEducationRows;
};

// Apply validation error classes/messages to each education row
ProfileHelper.prototype.addEducationRowErrors = function(arrValidationErrors){
	// Get all the education rows and loop through each one
	var rows = $('.edu-block');
	rows.each(function(index, el){
		// If this row has one or more validation errors
		if(arrValidationErrors[index]){
			var objRowValidationErrors = arrValidationErrors[index];

			// If there's a validation error for the degree type in this row, add appropriate class and error message
			if(objRowValidationErrors.DegreeType){
				var objDegreeTypeEl = $(el).find('.selectbox-container');
				objDegreeTypeEl.addClass('error');
				objDegreeTypeEl.prevAll('label').addClass('error');
				objDegreeTypeEl.after('<span class="validation-error">'+objRowValidationErrors.DegreeType[0]+'</span>');
			}
			
			// If there's a validation error for the school in this row, add appropriate class and error message
			if(objRowValidationErrors.School){
				var objSchoolEl = $(el).find('input#searchInput');
				var objDropdownContainer = $(el).find('.dropdown');
				objSchoolEl.addClass('error');
				objSchoolEl.prevAll('label').addClass('error');
				objDropdownContainer.after('<span class="validation-error">'+objRowValidationErrors.School[0]+'</span>');
			}
			
			// If there's a validation error for the year in this row, add appropriate class and error message
			if(objRowValidationErrors.YearGraduated){
				var objYearEl = $(el).find('input#edu-yr-grad-00');
				objYearEl.addClass('error');
				objYearEl.prevAll('label').addClass('error');
				objYearEl.after('<span class="validation-error">'+objRowValidationErrors.YearGraduated[0]+'</span>');
			}
			
			// If there's a validation error for the degree in this row, add appropriate class and error message
			if(objRowValidationErrors.Degree){
				var objDegreeEl = $(el).find('input#edu-deg-00');
				objDegreeEl.addClass('error');
				objDegreeEl.prevAll('label').addClass('error');
				objDegreeEl.after('<span class="validation-error">'+objRowValidationErrors.Degree[0]+'</span>');
			}
		}
	});
};

// Helper function to get the data for all social media rows currently on the page
ProfileHelper.prototype.getSocialRowData = function(){
	var arrSocialRows = [];
	$('.social-network-block').each(function(){
		var strSocialNetwork = $(this).find('select[id^="soc-net-"]').val();
		var strLink = $(this).find('[id^="soc-net-url-"]').val();
		var strRecordId = $(this).find('[id^="soc-net-record-id-"]').val();
		var objData = {
			SocialNetwork: strSocialNetwork,
			Link: strLink
		};
		if(strRecordId){
			objData.RecordID = strRecordId;
		}

		arrSocialRows.push(objData);
	});

	return arrSocialRows;
};

// Apply validation error classes/messages to each social media row
ProfileHelper.prototype.addSocialRowErrors = function(arrValidationErrors){
	// Get all the social media rows and loop through each one
	var rows = $('.social-network-block');
	rows.each(function(index, el){
		// If this row has one or more validation errors
		if(arrValidationErrors[index]){
			var objRowValidationErrors = arrValidationErrors[index];

			// If there's a validation error for the network in this row, add appropriate class and error message
			if(objRowValidationErrors.SocialNetwork){
				var objSocialNetworkEl = $(el).find('.selectbox-container');
				objSocialNetworkEl.addClass('error');
				objSocialNetworkEl.prevAll('label').addClass('error');
				objSocialNetworkEl.after('<span class="validation-error">'+objRowValidationErrors.SocialNetwork[0]+'</span>');
			}

			// If there's a validation error for the URL in this row, add appropriate class and error message
			if(objRowValidationErrors.Link){
				var objLinkEl = $(el).find('input[id^="soc-net-url-"]');
				objLinkEl.addClass('error');
				objLinkEl.prevAll('label').addClass('error');
				objLinkEl.after('<span class="validation-error">'+objRowValidationErrors.Link[0]+'</span>');
			}
		}
	});
};

// Create a new social media row via an AJAX, and add that to the page
ProfileHelper.prototype.getSocRow = function(){
	// Make Ajax call to WP back-end with action: 'render_social_row'
	// Return HTML with this
	var helper = this;
	$.ajax({
		method: "POST",
		url: urls.ajax,
		data: { action: "render_social_row" }
	})
	.done(function(data) {
		// Render actual markup on page - not console.log
		$('#social-container').append(data);
		helper.initSocRows();

		// Initialize select in the newly-added row
		var addedNetwork = $('.social-network-block').last();
		addedNetwork.find('select[id^="soc-net-"]').not('[multiple]').wrap('<div class="selectbox-container"></div>');
		// Alert the change in value when an option is selected -- TEST ONLY
		// addedNetwork.find('select[id^="soc-net-"]').on('change', function(){
		//     alert($(this).val());
		// });
	});
};

// Handler function to remove a social media row
ProfileHelper.prototype.removeSocRow = function(objElement, intRecordId){

	objElement.parent('.social-network-block').remove();

	/* TODO: Remove? Sticking with static button text "Add New Network" for now
	if($('.social-network-block').length === 0) {
		$('.btn-social-add').html('Add Network');
	}
	*/

	// Add this record id to the array of networks to be deleted on save, and show the warning message to save for removal to to effect
	if(intRecordId){
		arrDeleteSocialMediaRows.push(intRecordId);
		$('#social-remove-warning').removeClass('hidden');
	}
};

// Helper function to initialize the remove button click event for all social media row remove buttons
ProfileHelper.prototype.initSocRows = function(){
	var helper = this;
	$('.btn-social-remove').each(function(){
		$(this).off('click').on('click', function(e){
			e.preventDefault();
			var objRemoveButton = $(this);
			helper.removeSocRow(objRemoveButton, objRemoveButton.data('recordid'));
		});
	});

	/* TODO: Remove? Sticking with static button text "Add New Network" for now
	var intNumSocRows = $('.social-network-block').length;
	if(intNumSocRows === 0) {
		$('.btn-social-add').html('Add Network');
	}
	else if(intNumSocRows > 0){
		$('.btn-social-add').html('Add Another Network');
	}
	*/
};

// Helper function to get the social media record ids which should be delete on save
ProfileHelper.prototype.getDeletedSocRecordIds = function(){
	return arrDeleteSocialMediaRows;
};

ProfileHelper.prototype.getEduRow = function(){
	// Make Ajax call to WP back-end with action: 'render_education_row'
	// Return HTML with this
	var helper = this;
	var eduBlockCount = $('.edu-block').length;
	$('.btn-edu-add').addClass('c-btn--disabled');
	$.ajax({
		method: "POST",
		url: urls.ajax,
		data: { action: "render_education_row", 
			index: eduBlockCount // Pass the current number of education blocks to the back-end
		}
	})
	.done(function(data) {
		// Render actual markup on page - not console.log
		$('#edu-container').append(data);
		helper.initEduRows();

		// Initialize select in the newly-added row
		var addedEducation = $('.edu-block').last();
		addedEducation.find('#edu-type-00').not('[multiple]').wrap('<div class="selectbox-container"></div>');
		$('.btn-edu-add').removeClass('c-btn--disabled');
	});
};

// Handler function to remove a social media row
ProfileHelper.prototype.removeEduRow = function(objElement, intRecordId){

	objElement.parent('.edu-block').remove();

	/* TODO: Remove? Sticking with static button text "Add New Education" for now
	if($('.edu-block').length === 0) {
		$('.btn-edu-add').html('Add Education');
	}
	*/

	// Add this record id to the array of education rows to be deleted on save, and show the warning message to save for removal to to effect
	if(intRecordId){
		arrDeleteEducationRows.push(intRecordId);
		$('#education-remove-warning').removeClass('hidden');
	}
};

// Helper function to initialize the remove button click event for all education row remove buttons
ProfileHelper.prototype.initEduRows = function(){
	var helper = this;
	$('.btn-edu-remove').each(function(){
		$(this).off('click').on('click', function(e){
			e.preventDefault();
			var objRemoveButton = $(this);
			helper.removeEduRow(objRemoveButton, objRemoveButton.data('recordid'));
		});

		$('.edu-block').each(function() {
			const $container = $(this);
			const $searchInput = $container.find('.dropdown-input');
			const $dropdownList = $container.find('.dropdown-list');
			const $listItems = $dropdownList.find('li:not(.add-school)');
			const $collegeIdInput = $container.find('[id^=edu-college-id]');
			const $addSchoolLink = $container.find('.add-school');
	
			// Hide all items initially
			$listItems.hide();
			$addSchoolLink.hide();
	
			$addSchoolLink.on('mousedown', function(e) {
				e.preventDefault();
				e.stopPropagation();
			});

			// Add click handler for each list item
			$listItems.on('mousedown', function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				const $item = $(this);
				const text = $item.text();
				const val = $item.data('val');
				
				// Set values immediately
				$searchInput.val(text);
				$collegeIdInput.val(val);
			});
	
			$listItems.on('mouseup', function(e) {
				e.preventDefault();
				e.stopPropagation();

				$listItems.hide();
				$addSchoolLink.hide();
			});
	
			// Show items when input is focused
			$searchInput.on('focus', function() {
				const searchTerm = $searchInput.val().toLowerCase();
				
				$listItems.each(function() {
					const $item = $(this);
					const itemText = $item.text().toLowerCase();
					const abbr = $item.data('abbr').toLowerCase();
					
					if ((itemText.includes(searchTerm) || abbr.includes(searchTerm))) {
						$item.show();
					}
				});
				$addSchoolLink.show();
	
			});
	
			// Hide items when input loses focus
			$searchInput.on('blur', function(e) {
				e.preventDefault();
				e.stopPropagation();

				$listItems.hide();
				$addSchoolLink.hide();
			});
	
			// Handle input changes
			$searchInput.on('input', function() {
				if (document.activeElement === this) {
					const searchTerm = $searchInput.val().toLowerCase();
					let exactMatch = false;
	
					$listItems.each(function() {
						const $item = $(this);
						const itemText = $item.text();
						const itemTextLower = itemText.toLowerCase();
						const abbr = $item.data('abbr').toLowerCase();
	
						// Check for exact match (case insensitive)
						if (itemTextLower === searchTerm) {
							exactMatch = true;
							$collegeIdInput.val($item.data('val'));
							$searchInput.val(itemText); // Update with properly cased text
						}
	
						if ((itemTextLower.includes(searchTerm) || abbr.includes(searchTerm))) {
							$item.show();
						} else {
							$item.hide();
						}
					});
	
					// If no exact match found, set collegeId to false
					if (!exactMatch) {
						$collegeIdInput.val('false');
					}
				}
			});
		});
	});

	/* TODO: Remove? Sticking with static button text "Add New Education" for now
	var intNumEduRows = $('.edu-block').length;
	if(intNumEduRows === 0) {
		$('.btn-edu-add').html('Add Education');
	}
	else if(intNumEduRows > 0){
		$('.btn-edu-add').html('Add Another School');
	}
	*/
};

// Helper function to get the education record ids which should be delete on save
ProfileHelper.prototype.getDeletedEduRecordIds = function(){
	return arrDeleteEducationRows;
};

// Helper function to remove the updateSuccess URL parameter from the profile edit page, using the History API
// Based on http://stackoverflow.com/a/35515584
ProfileHelper.prototype.removeUpdateUrlParams = function(){
	// get the string following the ?
	var query = window.location.search.substring(1);

	// Is there a query string to be removed, and does it contain the updateSuccess parameter?
	if(query.length && query.indexOf('updateSuccess') >= 0) {
	   // are the new history methods available ?
	   if(window.history !== undefined && window.history.pushState !== undefined) {
			// if pushstate exists, add a new state the the history without the query string, this changes the url without reloading the page
			window.history.pushState({}, document.title, window.location.pathname);
	   }
	}
};
